import React from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import SupplierPage from "./steps/SupplierPage";
import useWizard from "../../hooks/useWizard";
import Schedule from "../schedule/Schedule";
import useRunOnce from "../../hooks/useRunOnce";
import {useParams} from "react-router-dom";
import {getPublicSupplierDataAction} from "../../store/actionCreators";
import {connect} from "react-redux";
import SeoComp from "../SeoComp";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        overflow: 'hidden'
    }

}));

const BookingWizard = ({getPublicSupplierData, supplierPersonalDetails, activitiesStrings}) => {
    const classes = useStyles()
    const {activeStep, handleBack, handleNext} = useWizard({});

    const {shortHash} = useParams()
    useRunOnce(() => {
        if (shortHash) {
            getPublicSupplierData(shortHash)
        }

    })
    const {fullName, images, description, professionId, address} = supplierPersonalDetails || {}
    const addressTitle = typeof address === 'string' ? address : address?.title;

    const {t} = useTranslation();

    return <div className={classes.root}>
        <SeoComp title={`${professionId?.heName} - ${fullName}`} image={images && images[0]?.url}
                 description={`${activitiesStrings} ${addressTitle ? `${t('in-address')}:${addressTitle}` : ''}, ${description ? description : ''}`}/>
        {activeStep === 0 && <SupplierPage handleNext={handleNext} supplierPersonalDetails={supplierPersonalDetails}/>}
        {activeStep === 1 && <Schedule isAdmin={false} handleNext={handleNext} handleBack={handleBack}/>}
    </div>
}

const mapStateToProps = (state) => ({
    supplierPersonalDetails: state.general.supplier?.personalData,
    activitiesStrings: state.general.supplier?.activities.map(({subProfessionId: {heName}}) => heName).join(', ')
})
const mapDispatchToProps = dispatch => ({
    getPublicSupplierData: getPublicSupplierDataAction(dispatch),
})
export default connect(mapStateToProps, mapDispatchToProps)(BookingWizard);